const API_ENDPOINTS = {
    AUTH: {
        LOGIN: 'login',
        LOGOUT: 'logout',
        REGISTER: 'registration',
        VERIFY_EMAIL: 'varify_email',
        VERIFY_OTP: 'verify_otp',
        FORGOT_PASSWORD: 'forgot_password',
    },
    PRODUCT: 'product',
    PRODUCT_LIST: 'product_list',
    PRODUCT_LIST_BY_ID: 'product_by_id',
    PRODUCT_LIST_BY_CATEGORY_ID: 'fetch_product_by_category_id',
    SHOP_LOGIN: 'shop_login',
    SHOPS: 'shop_list',
    CATEGORIES: 'category',
    SLIDER_IMAGES: 'sliderimages',
    ADDRESS: 'address',
    ORDER: 'order',
    PAYMENT_VERIFY: 'payment_verify',
    BRAND: 'brand',
    SIZE: 'size',
    NEWSLETTER: 'newsletter',
    COUPON: 'get_coupons',
    ADD_WISHLIST: 'add_cart',
    WISHLIST: 'wishlist',
    DELETE_WISHLIST: 'delete_cart',
    USER_UPDATE:'user/update',
    ORDERS_DETAILS: "order-list",
    PAYMENT_LOG:"log-payment",
    RAZORPAY:"razorpay"
}
export default API_ENDPOINTS